module.exports = __webpack_public_path__ + "static/assets/15ed9ff9309f9d64fd014af3ed4e3183.png";